import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, Routes, Navigate } from 'react-router-dom';
import '../src/assets/css/globalvariables/GlobalVariables.css';
import './App.css';
import AIChatbot from './components/user/alchatbot/AiChatBot.js';
import Auth from './screens/user/authentication/auth.js';
import Home from './screens/user/home/Home.js';
import Contact from './screens/user/contact/Contact.js';
import Mechanics from './screens/user/maintain/Maintain.js';
import Blogs from './screens/user/blogs/Blogs.js';
import MechanicSingleDetailPage from './subscreens/users/Maintain/mechanicsingledetail/MechanicSingleDetailPage.js';
import MechanicChatPage from './subscreens/users/Maintain/bookappointment/mechanicchatmodal/MechanicTalkNow.js';
import ShopPage from './screens/user/shoppage/ShopPage.js';
import AboutUsPage from '../src/screens/user/AboutUsPage/AboutUsPage.js';
import Equipments from '../src/screens/user/rent/Rent.js'
import ShopsListingPage from './subscreens/users/shop/shoplistingpage/ShopListingPage.js';
import IndividualShopPage from './components/user/shoppage/individualshoppage/IndividualShopPage.js';
import ProductDetailPage from './subscreens/users/shop/productdetailpage/ProductDetailPage.js';
import EquipmentChat from './subscreens/users/shop/productdetailpage/equipmentchat/EquipmentChat.js';
import Cancelbooking from './components/user/general/stripepages/cancelbooking/Cancelbooking.js';
import MechanicPaymentSuccess from './subscreens/users/Maintain/bookappointment/mechanicpaymentsuccess/MechanicPaymentSuccess.js';
import MechanicPaymentCancel from './subscreens/users/Maintain/bookappointment/mechanicpaymentcancel/MechanicPaymentCancel.js';




import UserDashboard from './screens/Useradmin/userdashboard/UserDashboard.js';
import MyRentals from './screens/Useradmin/myrentals/MyRentals.js';
import UserMaintenance from './screens/Useradmin/maintenance/UserMaintenance.js';
import BookingHistory from './screens/Useradmin/bookinghistory/BookingHistory.js';
import Messages from './screens/Useradmin/messages/Messages.js';
import Payments from './screens/Useradmin/payments/Payments.js';
import Favorites from './screens/Useradmin/favorites/Favorites.js';
import Profile from './screens/Useradmin/profile/Profile.js';
import UserNotification from './screens/Useradmin/notifications/UserNotification.js';
import Dispute from './screens/Useradmin/userdispute/UserDispute.js';
import UserSettings from './screens/Useradmin/setting/Settings.js';


import ForgotPassword from './components/user/general/forgotpassword/ForgotPassword.js';
import Dashboard from './screens/superadmin/dashboard/Dashboard.js';
import RentalOwnersManagement from './screens/superadmin/usersmanagment/rentalownermangment/RentalOwner.js';
import SubAdmin from './screens/superadmin/subadmin/SubAdmin.js';
import MechanicsManagement from './screens/superadmin/usersmanagment/mechanicsmanagment/MechanicsManagment.js';
import EndUsersManagement from './screens/superadmin/usersmanagment/endusersmanagment/EndUsersManagment.js';
import ReportsAnalytics from './screens/superadmin/reportsanalytics/ReportsAnalytics.js';
import Reviews from './screens/Useradmin/reviews/Reviews.js';
import EquipmentDetails from './screens/Useradmin/equipmentdetails/EquipmentDetails.js';
import DisputeManagement from './screens/superadmin/disputemanagment/DisputeManagement.js';
import BlogManagement from './screens/superadmin/blogmanagement/BlogManagement.js';
import CategoryManagement from './screens/superadmin/categorymanagment/CategoryManagement.js';
import SystemSettings from './screens/superadmin/systemsetting/SystemSettings.js';
import RatingReviews from './screens/superadmin/ratingreview/RatingReviews.js';
import EarningManagement from './screens/superadmin/earningmanagment/EarningManagment.js';
import AdminLogin from './screens/superadmin/adminlogin/Auth.js';
import Notification from './screens/superadmin/adminnotifications/Notification.js';
// import ReportingRequest from './screens/superadmin/reportingrequest/ReportingRequest.js';
import MaintenceRequest from './screens/superadmin/maintenancerequest/MaintenceRequest.js';





import Registration from './screens/equipmentrentaladmin/Registration/Registration.js';
import Login from './screens/equipmentrentaladmin/login/Login.js';
import RentalDashboard from './screens/equipmentrentaladmin/dashboard/RentalDashboard.js';
import MyEquipment from './screens/equipmentrentaladmin/myequipment/MyEquipment.js';
import AddNewEquipment from './screens/equipmentrentaladmin/myequipment/addnewequipment/AddNewEquipment.js';
// import AddEquipmentModal from './subscreens/equipmentrentaladmin/myequipment/addequipmentmodal/AddEquipmentModal';
// import EditEquipment from './subscreens/equipmentrentaladmin/myequipment/editequipmentmodal/EditequipmentModal.js';
import Rentals from './screens/equipmentrentaladmin/rentals/Rentals.js';
import Maintenance from './screens/equipmentrentaladmin/maintenance/Maintenance.js';
import RequestButton from './screens/equipmentrentaladmin/maintenance/requestbutton/RequestButton';
import MechanicDetailPage from './screens/equipmentrentaladmin/maintenance/requestbutton/mechanicsingledetailpage/MechanicSingleDetailPage.js';
import RentalReviews from './screens/equipmentrentaladmin/reviews/RentalReviews.js';
import MechanicTalkNow from './screens/equipmentrentaladmin/maintenance/requestbutton/mechanicsingledetailpage/talknow/TalkNow.js';
import AdminConversations from "./screens/equipmentrentaladmin/conversation/Conversation.js";
import Earnings from './screens/equipmentrentaladmin/earnings/Earnings.js';
import RentalDispute from './screens/equipmentrentaladmin/dispute/RentalDispute.js';
import Settings from './screens/equipmentrentaladmin/settings/Settings.js';
import RentalProfile from './screens/equipmentrentaladmin/rentalprofile/RentalProfile.js';
import RentalNotification from './screens/equipmentrentaladmin/notification/RentalNotification.js'
import BlogDetail from './subscreens/users/blogs/blogdetail/BlogDetail.js';
import OwnerEquipment from './subscreens/superadmin/UserManagment/rentalownermanagment/ownerequipment/OwnerEquipment.js';
import SpecilizationManagment from './screens/superadmin/specilizationmanagment/SpecilizationManagment.js';
import BookingManagement from './screens/superadmin/bookingmanagement/BookingManagement.js';
import PayoutsManagement from './screens/superadmin/payoutmanagement/PayoutManagement.js';
import RefundManagement from './screens/superadmin/refundmanagement/RefundManagement.js';
import TopupRequests from './screens/superadmin/topuprequests/TopUpRequests.js';
import PageNotFound from './components/user/general/pagenotfound/PageNotFound.js';


import MechanicLogin from './screens/mechanic/login/Login.js';
import MechanicRegister from './screens/mechanic/register/Register.js'
import MechanicDashboard from './screens/mechanic/mechanicdashboard/MechanicDashboard.js';
import MaintenanceRequests from './screens/mechanic/maintenancerequest/MaintenanceRequest.js';
import MechanicEarning from './screens/mechanic/earnings/Earnings.js';
import MechanicReviews from './screens/mechanic/reviewrating/ReviewsRating.js';
import MechanicDisputes from './screens/mechanic/dispute/Dispute.js';
import MechanicNotifications from './screens/mechanic/notifications/Notification.js';
import MechanicProfile from './screens/mechanic/profile/Profile.js';
import MechanicKyc from './screens/mechanic/kyc/KYC.js';
import MechanicMessages from './screens/mechanic/messages/Mechanicmessages.js';
import SuccessBooking from './components/user/general/stripepages/succesbooking/SuccessBooking.js';
import AdminContactForm from './screens/superadmin/contactform/ContactForm.js';
import TopupSuccess from './screens/mechanic/earnings/topupsuccess/TopupSuccess.js';
import TopupCancelled from './screens/mechanic/earnings/topupcancel/TopupCancel.js';





function App() {
  return (
    <>
      <Routes>

        <Route path="/general/forgot-password/:userType" element={<ForgotPassword />} />
        <Route path='*' element={<PageNotFound />} />
        <Route path='/' element={<Home />} />
        <Route path='/auth' element={<Auth />} />
        <Route path='/mechanics' element={<Mechanics />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/equipments' element={<Equipments />} />
        <Route path='/aboutus' element={<AboutUsPage />} />
        <Route path='/blog' element={<Blogs />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />

        <Route path="/mechanic/:id" element={<MechanicSingleDetailPage />} />
        <Route path="/mechanic-chat/:id" element={<MechanicChatPage />} />
        <Route path='/shop' element={<ShopPage />} />
        <Route path="/shops" element={<ShopsListingPage />} />
        <Route path="/shop/:id" element={<IndividualShopPage />} />
        <Route path="/product/:id" element={<ProductDetailPage />} />

        <Route path="/equipment/:id/chat" element={<EquipmentChat />} />

        <Route path="/payment-cancel" element={<Cancelbooking />} />
        <Route path="/payment-success" element={<SuccessBooking />} />

       <Route path='/mechanic-admin-topup-cancel' element={<TopupCancelled />} />
       <Route path='/mechanic-admin/topup-success' element={<TopupSuccess />} />



        {/* /////////////////////////////////RENTAL---DAHBOARD////////////////////////////////////////////// */}


        <Route path="/rental-admin/registration" element={<Registration />} />
        <Route path="/rental-admin/login" element={<Login />} />
        <Route path="/rental-admin/dashboard" element={<RentalDashboard />} />
        <Route path="/rental-admin/MyEquipment" element={<MyEquipment />} />
        <Route path="/rental-admin/addEquipment" element={<AddNewEquipment />} />
        <Route path="/rental-admin/rentals" element={<Rentals />} />
        <Route path="/rental-admin/reviews" element={<RentalReviews />} />
        <Route path="/rental-admin/earnings" element={<Earnings />} />
        <Route path="/rental-admin/messages" element={<AdminConversations />} />
        <Route path="/rental-admin/maintenance" element={<Maintenance />} />
        <Route path="/rental-admin/requestbutton" element={<RequestButton />} />
        <Route path="/rental-admin/mechanic/:id" element={<MechanicDetailPage />} />

        <Route path="/rental-admin/mechanic-chat/:id" element={<MechanicTalkNow />} />
        <Route path="/rental-admin/rentaldispute" element={<RentalDispute />} />
        <Route path="/rental-admin/notification" element={<RentalNotification />} />
        <Route path="/rental-admin/settings" element={<Settings />} />
        <Route path="/rental-admin/profile" element={<RentalProfile />} />






        {/* ////////////////////////////////////USER---DASHBOARD///////////////////////// */}
        <Route path="/user">
          <Route path="/user/dashboard" element={<UserDashboard />} />
          <Route path="/user/equipment/:id" element={<EquipmentDetails />} />
          <Route path="/user/my-rentals" element={<MyRentals />} />
          <Route path="/user/maintenance" element={<UserMaintenance />} />
          <Route path="/user/booking-history" element={<BookingHistory />} />
          <Route path="/user/messages" element={<Messages />} />
          <Route path="/user/payments" element={<Payments />} />
          <Route path="/user/dispute" element={<Dispute />} />
          {/* <Route path="/user/favorites" element={<Favorites />} /> */}
          <Route path="/user/reviews" element={<Reviews />} />
          <Route path="/user/profile" element={<Profile />} />
          <Route path="/user/usernotification" element={<UserNotification />} />
          <Route path="/user/setting" element={<UserSettings />} />

        </Route>




        {/* ///////////////////////////////SUPERADMINDASHBOARD ////////////////////////////////////// */}
        <Route path='/admin/login' element={<AdminLogin />} />
        <Route path='/admin/dashboard' element={<Dashboard />} />
        <Route path='/admin/sub-admin' element={<SubAdmin />} />
        <Route path='/admin/category' element={<CategoryManagement />} />
        <Route path='/admin/users/rental-owners' element={<RentalOwnersManagement />} />
        <Route path='/superadmin/users/rental-owners/equipments' element={<OwnerEquipment />} />
        <Route path='/admin/users/mechanics' element={<MechanicsManagement />} />
        <Route path='/admin/specilization' element={<SpecilizationManagment />} />
        <Route path='/admin/earning' element={<EarningManagement />} />
        <Route path='/admin/rating-review' element={<RatingReviews />} />
        <Route path='/admin/blogs' element={<BlogManagement />} />
        <Route path='/admin/users/end-users' element={<EndUsersManagement />} />
        <Route path='/admin/maintenance-request' element={<MaintenceRequest />} />
        <Route path='/admin/bookings' element={<BookingManagement />} />
        <Route path='/admin/payouts' element={<PayoutsManagement />} />
        <Route path='/admin/refunds' element={<RefundManagement />} />
        <Route path='/admin/topup' element={<TopupRequests />} />
        <Route path='/admin/contactform' element={<AdminContactForm />} />
        {/* <Route path='/admin/equipment-listing' element={<AllEquipment />} /> */}
        <Route path='/admin/disputes' element={<DisputeManagement />} />
        <Route path='/admin/reports-analytics' element={<ReportsAnalytics />} />
        <Route path='/admin/settings' element={<SystemSettings />} />
        <Route path='/admin/notifications' element={<Notification />} />


        <Route path='/mechanic-admin/register' element={<MechanicRegister />} />
        <Route path='/mechanic-admin/login' element={<MechanicLogin />} />
        <Route path='/mechanic-admin/dashboard' element={<MechanicDashboard />} />
        <Route path='/mechanic-admin/requests' element={<MaintenanceRequests />} />
        <Route path='/mechanic-admin/kyc' element={<MechanicKyc />} />
        <Route path='/mechanic-admin/messages' element={<MechanicMessages />} />
        <Route path='/mechanic-admin/earnings' element={<MechanicEarning />} />
        <Route path='/mechanic-admin/reviews' element={<MechanicReviews />} />
        <Route path='/mechanic-admin/dispute' element={<MechanicDisputes />} />
        <Route path='/mechanic-admin/notification' element={<MechanicNotifications />} />
        <Route path='/mechanic-admin/profile' element={<MechanicProfile />} />
      </Routes>
    </>
  );
}

export default App;
